import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import { colors } from '../../../colors';
import TooltipContent from '../../debtorClaimEvents/presentation/TooltipContent';

interface Props {
  claimInformationTooltip: { [key: string]: string };
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: colors.marble,
    color: colors.black,
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    fontSize: '0.875rem',
    fontWeight: '500',
    maxWidth: '600px',
    marginTop: '4px',
    padding: '10px',
  },
}));

export default function ClaimInformationIcon({ claimInformationTooltip }: Props) {
  if (!claimInformationTooltip || Object.keys(claimInformationTooltip).length === 0) {
    return null;
  }

  return (
    <HtmlTooltip
      title={
        Object.keys(claimInformationTooltip).map((key) => (
          <TooltipContent key={key} header={key} content={claimInformationTooltip[key]} />
        ))
      }
      placement="right"
      enterDelay={100}
      leaveDelay={200}
    >
      <IconButton
        size="small"
        color="info"
        sx={{ mt: '-3px', padding: '2px', cursor: 'default' }}
        aria-label="Fakturainformasjon"
      >
        <InfoIcon sx={{ fontSize: '14px', width: '1.4em', height: '1.4em' }} />
      </IconButton>
    </HtmlTooltip>
  );
}